import React, { useState } from "react";
import { FlexBox, Option } from "../../primitives";
import {
  LabelStyled,
  PrimaryButton,
  StyledInput,
  StyledSelect,
} from "../../common/common.style";
import { CardToSyncStatusEnum, CardToSyncSourceEnum } from "magic-shared-types";

interface FilterTableSyncProps {
  status?: CardToSyncStatusEnum;
  setStatus: (value: CardToSyncStatusEnum) => void;
  page: number;
  onPageChange: (value: number) => void;
  total: number;
  pageSize: number;
  market?: CardToSyncSourceEnum;
  setMarket: (arg1: CardToSyncSourceEnum) => void;
  setName: (arg1: string) => void;
}

export const FilterTableSync: React.FC<FilterTableSyncProps> = ({
  status,
  setStatus,
  page,
  onPageChange,
  total,
  pageSize,
  market,
  setMarket,
  setName,
}) => {
  const [localName, setLocalName] = useState("");
  const totalPages = Math.ceil(total / pageSize);

  return (
    <FlexBox
      css={{
        padding: 16,
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        gap: 20,
      }}
    >
      <FlexBox css={{ gap: 20 }}>
        <FlexBox css={{ gap: 10, alignItems: "center" }}>
          <StyledInput
            type="text"
            value={localName}
            onChange={(e) => {
              setLocalName(e.target.value);
            }}
            onBlur={() => {
              setName(localName);
            }}
            placeholder="Search by name"
            css={{ width: 200 }}
          />
          <LabelStyled>MARKET</LabelStyled>
          <StyledSelect
            value={market}
            onChange={(e) => {
              onPageChange(1);
              setMarket(e.target.value as CardToSyncSourceEnum);
            }}
            css={{ width: 200 }}
          >
            <Option value="">All</Option>
            <Option value={CardToSyncSourceEnum.CARDMARKET}>
              {CardToSyncSourceEnum.CARDMARKET}
            </Option>
            <Option value={CardToSyncSourceEnum.CARDTRADER}>
              {CardToSyncSourceEnum.CARDTRADER}
            </Option>
          </StyledSelect>
        </FlexBox>

        <FlexBox css={{ gap: 10, alignItems: "center" }}>
          <LabelStyled>STATUS</LabelStyled>
          <StyledSelect
            value={status}
            onChange={(e) => {
              onPageChange(1);
              setStatus(e.target.value as CardToSyncStatusEnum);
            }}
            css={{ width: 200 }}
          >
            <Option value="">All</Option>
            <Option value={CardToSyncStatusEnum.PENDING}>PENDING</Option>
            <Option value={CardToSyncStatusEnum.SUCCESS}>SUCCESS</Option>
            <Option value={CardToSyncStatusEnum.FAILED}>FAILED</Option>
            <Option value={CardToSyncStatusEnum.PARTIALLY_SUCCESSFUL}>
              PARTIALLY SUCCESSFUL
            </Option>
            <Option value={CardToSyncStatusEnum.NOT_SUPPORTED}>
              NOT SUPPORTED
            </Option>
          </StyledSelect>
        </FlexBox>
      </FlexBox>

      {totalPages ? (
        <FlexBox style={{ marginTop: 12, alignItems: "center" }}>
          <PrimaryButton
            disabled={page === 1}
            isDisabled={page === 1}
            onClick={() => onPageChange(Math.max(page - 1, 1))}
            css={{ width: 50 }}
          >
            Prev
          </PrimaryButton>
          <LabelStyled style={{ margin: "0 10px" }}>
            Page {page} / {totalPages}
          </LabelStyled>
          <PrimaryButton
            disabled={page >= totalPages}
            isDisabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
            css={{ width: 50 }}
          >
            Next
          </PrimaryButton>
        </FlexBox>
      ) : null}
    </FlexBox>
  );
};
